import gql from 'graphql-tag';

export default gql`
mutation insertNewFolder($obj: folders_insert_input!) {
  insert_folders_one(object: $obj) {
    folder_id
  }
}
`;
